//types
import { HeaderGroupProps } from '../../types';

const HeaderGroup = ({ classes, nameGroup }: HeaderGroupProps) => {
  return <th className={`text-left text-specialGray-075 uppercase font-medium text-xs p-2 px-4 ${classes}`}>{nameGroup}</th>;
};

export default HeaderGroup;
